<button class="icon-left lc-no-hover-button" mat-icon-button [matMenuTriggerFor]="statusFilterMenu" aria-label="Filter">
    <mat-icon [ngClass]="{'material-icons-outlined' : !hasFilterSelected()}">filter_alt</mat-icon>
</button>
<mat-menu #statusFilterMenu="matMenu">
    <div class="menuContainer" (click)="$event.stopPropagation()">
        <div>
            <button class="clear-button" mat-icon-button (click)="clearFilters()">
                <div class="icon-container">
                    <mat-icon>block</mat-icon>
                </div>
                <span class="text-container">Clear filter</span>
            </button>
        </div>
        <div class="selection-list">
            <table aria-label="Status filter table" class="lc-table" mat-table [dataSource]="dataSource">
                <!-- Checkbox Column -->
                <ng-container matColumnDef="select">
                    <th mat-header-cell *matHeaderCellDef>
                        <mat-checkbox color="primary" (change)="$event ? masterToggle() : null"
                                      [checked]="selection.hasValue() && isAllSelected()"
                                      [indeterminate]="selection.hasValue() && !isAllSelected()"
                                      [aria-label]="'select'"
                                      color="primary">
                        </mat-checkbox>
                    </th>
                    <td mat-cell *matCellDef="let row">
                        <mat-checkbox color="primary" class="selection-checkbox" (click)="$event.stopPropagation()"
                            (change)="changeSelection($event, row.name)" [checked]="selection.isSelected(row.name)"
                            [aria-label]="row">
                        </mat-checkbox>
                    </td>
                </ng-container>
                <ng-container matColumnDef="icon">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let element"><mat-icon [svgIcon]="element.icon"></mat-icon></td>
                </ng-container>
                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let element">{{element.name | titlecase}}</td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="changeSelection($event, row.name)"></tr>
            </table>
        </div>
    </div>
</mat-menu>